'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onWindowClosing = exports.stopLogger = exports.startLogger = exports.addLogTrackerEvent = exports.addClickTrackerEvent = exports.addPerformanceTrackerEvent = exports._addToStreamLog = exports.sendLogs = exports._purgeLogs = exports._removeDelimiters = exports._isUserActive = exports._pruneRecentsCache = exports._isRecentlyCached = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ModuleReducer = require('../components/module/ModuleReducer');

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _OidcService = require('../services/OidcService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STREAM_LOGGER_INTERVAL = 60000;
var CLICK_TRACK_CACHE_TIMESPAN = 15000;
var ENDPOINT = 'https://api-cwservices-na.myconnectwise.net/usage/log';
var API_KEY = 'lFlxKUvG8C8a7i1BH5jtKaHicYR8C5X78T4xPBsF';

// Elasticsearch date format
var DATE_FORMAT = "YYYY/MM/DD HH:mm:ss";
var DATE_FORMAT_KIBANA = "YYYY/MM/DD HH:mm:ss.SSS";

var logMessages = [];
var processLogsTimer = void 0;

// cache of click tracks with most recent timestamp
var recentsCache = {}; // {string: number}

/**
 * Checks recentsCache to determine if event has
 * been logged within the threshold timespan
 * @param {ClickTrack} event 
 * @returns {boolean}
 */
var _isRecentlyCached = exports._isRecentlyCached = function _isRecentlyCached(event) {
  // unique key is composed of source and value
  var cacheKey = event.source + '_' + event.action + '_' + event.name;

  // now in milliseconds
  var now = (0, _moment2.default)().valueOf();

  // get timestamp from cache
  var timeStamp = recentsCache[cacheKey];

  var isRecent = false;

  // if already in cache
  if (timeStamp) {
    var timeDiff = now - timeStamp;

    // if time difference is less than threshold, then it is considered recently cached
    /* istanbul ignore else */
    if (timeDiff < CLICK_TRACK_CACHE_TIMESPAN) {
      isRecent = true;
    }
  }

  // always update cache with latest timestamp
  recentsCache[cacheKey] = now;
  return isRecent;
};

/**
 * Clears items from recentsCache whose timestamp is greater than threshold
 * This avoids having the cache grow indefinitely over time
 */
var _pruneRecentsCache = exports._pruneRecentsCache = function _pruneRecentsCache() {
  var now = (0, _moment2.default)().valueOf();

  for (var key in recentsCache) {
    /** istanbul ignore else */
    if (recentsCache.hasOwnProperty(key)) {
      var timeDiff = now - recentsCache[key];

      // delete if time difference is greater than threshold
      /* istanbul ignore if */
      if (timeDiff > CLICK_TRACK_CACHE_TIMESPAN) {
        delete recentsCache[key];
      }
    }
  }
};

/**
 * Return if user is currently active (GWT)
 * @returns {boolean}
 */
var _isUserActive = exports._isUserActive = function _isUserActive() {
  // lastActive is being set every time a GWT PresenterCompleted event fires.
  var lastActive = localStorage.getItem("lastActive");

  if (lastActive) {
    // Get time different on when was last time user was active
    var timediff = (0, _moment2.default)().valueOf() - Number(lastActive);
    var minutes = timediff / (1000 * 60);

    if (minutes > 480.0 /* 8 hours */) {
        return false;
      }
  }

  // Default to true
  return true;
};

/**
 * Gets UTC date format string expected by Kibana
 * @param {any} date 
 * @param {string} format 
 * @returns {string}
 */
var _getDate = function _getDate(date, format) {
  return date.utc().format(format);
};

/**
 * Removes various characters such as spaces and hyphens that
 * appear as data delimiters in ElasticSearch
 * @param {string} text 
 * @returns {string}
 */
var _removeDelimiters = exports._removeDelimiters = function _removeDelimiters(text) {
  if (text) {
    return text.replace(new RegExp('[ +-]', 'g'), '_');
  }
  return text;
};

/**
 * Attempts to send final data to server before closing instance
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon
 * http://qnimate.com/sending-data-to-server-on-page-unload/
 * @param {string} endPoint 
 * @param {string} payload 
 */
var _purgeLogs = exports._purgeLogs = function _purgeLogs(endPoint, payload) {
  // if (navigator.sendBeacon) {
  //   navigator.sendBeacon(endPoint, payload);
  // }
  // else {
  var request = new XMLHttpRequest();
  request.open('PUT', endPoint, false); // sync call
  request.setRequestHeader('x-api-key', API_KEY);
  request.setRequestHeader('Content-Type', 'application/json');
  request.send(payload);
  // }
};

/**
 * Sends logged messages to server and clears out current list
 * @param {boolean} isClosing
 */
var sendLogs = exports.sendLogs = function sendLogs() {
  var isClosing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  // if user is inactive, return
  if (!_isUserActive() || logMessages.length === 0) {
    return;
  }

  // Clone the current list and clear it
  var logs = logMessages;
  logMessages = [];

  var payload = (0, _stringify2.default)({ logs: logs });

  // ship the data to the server
  if (isClosing) {
    _purgeLogs(ENDPOINT, payload);
  } else {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('x-api-key', API_KEY);

    fetch(ENDPOINT, {
      method: 'PUT',
      body: payload,
      headers: headers
    });
  }
};

/**
 * Sends logs and clears recentlyCached list
 */
var _onTimerElapsed = function _onTimerElapsed() {
  sendLogs();
  _pruneRecentsCache();
};

/**
 * Populates the tracking info with information on the current user's session
 * and adds it to the stream log
 * @param {string} type
 * @param {Object} trackingInfo 
 */
var _addToStreamLog = exports._addToStreamLog = function _addToStreamLog(type, trackingInfo) {
  var state = (0, _Store2.default)().getState();
  var partnerId = (0, _OidcService.getPartnerId)(state.oidc);
  var now = (0, _moment2.default)();
  var utcNow = _getDate(now, DATE_FORMAT);

  trackingInfo.type = _removeDelimiters(type);
  trackingInfo.appId = _removeDelimiters((0, _ModuleReducer.getModuleId)(state.module));
  trackingInfo.appBuild = _removeDelimiters((0, _ModuleReducer.getModuleConfig)(state.module, ['build']));
  trackingInfo.appVersion = _removeDelimiters((0, _ModuleReducer.getModuleConfig)(state.module, ['version']));
  trackingInfo.appRegion = _removeDelimiters((0, _ModuleReducer.getModuleConfig)(state.module, ['region']));
  trackingInfo.os = _removeDelimiters((0, _ModuleReducer.getOs)(state.module));
  trackingInfo.osVersion = _removeDelimiters((0, _ModuleReducer.getOsVersion)(state.module));
  trackingInfo.client = _removeDelimiters((0, _ModuleReducer.getClient)(state.module));
  trackingInfo.clientVersion = _removeDelimiters((0, _ModuleReducer.getClientVersion)(state.module));
  trackingInfo.platform = _removeDelimiters((0, _ModuleReducer.getPlatform)(state.module));
  trackingInfo.date = utcNow; // No need to remove spaces for date
  trackingInfo.partnerId = partnerId ? _removeDelimiters(partnerId) : _removeDelimiters((0, _ModuleReducer.getCompanyName)(state.module)) || "[none]"; // default to [none] for allowed null partition
  trackingInfo.userSessionId = _removeDelimiters((0, _ModuleReducer.getUserSessionId)(state.module)); //user session, same for different tabs, different for new logins
  trackingInfo.appSessionId = _removeDelimiters((0, _ModuleReducer.getAppSessionId)(state.module)); //app session, different for different tabs
  trackingInfo.sessionTag = _removeDelimiters((0, _ModuleReducer.getSessionTag)(state.module));

  trackingInfo.ticks = now.valueOf();
  logMessages.push(trackingInfo);
};

/**
 * Adds performance tracker event
 * @param {PerformanceTrack} event 
 */
var addPerformanceTrackerEvent = exports.addPerformanceTrackerEvent = function addPerformanceTrackerEvent(event) {
  // if timer hasn't started, then module data is not available yet
  // also, don't queue up logs if they are not going to be processed and cleared out
  if (!processLogsTimer) {
    return;
  }

  var trackingInfo = {
    'name': _removeDelimiters(event.name),
    'action': _removeDelimiters(event.action),
    'clientAction': _removeDelimiters(event.clientAction),
    'clientActionId': _removeDelimiters(event.clientActionId),
    'startTime': _getDate(event.startTime, DATE_FORMAT_KIBANA),
    'endTime': _getDate(event.endTime, DATE_FORMAT_KIBANA),
    'elapsedTime': event.elapsedTime,
    'X-Amzn-Trace-Id': _removeDelimiters(event.amazonTraceId),
    'custom': event.custom
  };

  _addToStreamLog('PerformanceTrack', trackingInfo);
};

/**
 * Adds click tracker event
 * @param {ClickTrack} event 
 * @param {boolean} [useRecentsCache]
 */
var addClickTrackerEvent = exports.addClickTrackerEvent = function addClickTrackerEvent(event) {
  var useRecentsCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  // if timer hasn't started, then module data is not available yet
  // also, don't queue up logs if they are not going to be processed and cleared out
  if (!processLogsTimer) {
    return;
  }

  // use recent cache system to avoid logging spammed actions
  if (useRecentsCache && _isRecentlyCached(event)) {
    return;
  }

  var trackingInfo = {
    'name': _removeDelimiters(event.name),
    'action': _removeDelimiters(event.action),
    'source': _removeDelimiters(event.source),
    'custom': event.custom
  };

  _addToStreamLog('ClickTrack', trackingInfo);
};

/**
 * Adds log tracker event
 * @param {string} category
 * @param {string} message 
 */
var addLogTrackerEvent = exports.addLogTrackerEvent = function addLogTrackerEvent(category, message) {
  // do not log empty messages
  if (!message) {
    return;
  }

  // if timer hasn't started, then module data is not available yet
  // also, don't queue up logs if they are not going to be processed and cleared out
  if (!processLogsTimer) {
    return;
  }

  var trackingInfo = {
    'category': category,
    'message': message
  };

  _addToStreamLog('LogTrack', trackingInfo);
};

/**
 * Starts the tracking to send logs over every 60 secs
 */
var startLogger = exports.startLogger = function startLogger() {
  /* istanbul ignore else */
  if (!processLogsTimer) {
    processLogsTimer = setInterval(_onTimerElapsed, STREAM_LOGGER_INTERVAL);
  }
};

/**
 * Stops the tracking logger
 */
var stopLogger = exports.stopLogger = function stopLogger() {
  /* istanbul ignore else */
  if (processLogsTimer) {
    sendLogs(); // send any queued logs
    clearInterval(processLogsTimer);
  }
  processLogsTimer = undefined;
};

/**
 * Sends all existing queued logs
 */
var onWindowClosing = exports.onWindowClosing = function onWindowClosing() {
  sendLogs(true);
};

// automatically kick off logger as early as possible
startLogger();


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/StreamLogger.js
// module id = 150
// module chunks = 10